/**
 * @generated SignedSource<<64b6d8b86557338ce646901cf7430d6a>>
 * @relayHash d79a1b458e808407b82c4438022bf749
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 00f3628c39a48153527b8dc43e0b0886e320b7dc266b3e8f4c82a245ba29c2fc

import type { ConcreteRequest } from 'relay-runtime';
export type AgenticPlanToolInChatCompleteConversationMutation$variables = {
  cloudId: string;
  conversationId: string;
};
export type AgenticPlanToolInChatCompleteConversationMutation$data = {
  readonly convoAi_completeConversation: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type AgenticPlanToolInChatCompleteConversationMutation = {
  response: AgenticPlanToolInChatCompleteConversationMutation$data;
  variables: AgenticPlanToolInChatCompleteConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
      }
    ],
    "concreteType": "ConvoAiUpdateConversationStatePayload",
    "kind": "LinkedField",
    "name": "convoAi_completeConversation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgenticPlanToolInChatCompleteConversationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgenticPlanToolInChatCompleteConversationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "00f3628c39a48153527b8dc43e0b0886e320b7dc266b3e8f4c82a245ba29c2fc",
    "metadata": {},
    "name": "AgenticPlanToolInChatCompleteConversationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f0d717c581b8c906f07ee272429490d6";

export default node;
